module.exports = __webpack_public_path__ + "static/media/social-facebook.1bac9fc4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/auth/social-facebook.svg
// module id = 155
// module chunks = 0